import Papa from 'papaparse';

export const downloadFile = (matches, channel) => {
	const output = matches.map((item) => ({
		barcode: item.barcode,
		title: item.title,
		price: item.price,
		markup: `${item.deliveryMarkup?.[channel]}%`
	}));

	const csv = Papa.unparse(output);
	const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
	const url = URL.createObjectURL(blob);

	const link = document.createElement('a');
	link.setAttribute('download', 'custom-markups.csv');
	link.setAttribute('href', url);
	document.body.appendChild(link);
	link.click();
};
